import { useFileUpload as useFileUploadREST } from '@risksmart-app/components/src/file/useFileUpload';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';

import { useFileUploadTRPC } from './useFileUploadTRPC';

/**
 * Flag-gated wrapper over the V2 REST upload flow
 * (`@risksmart-app/components/src/file/useFileUpload`) and its tRPC twin.
 * Consumers import THIS — never `useFileUploadTRPC` directly.
 */
export const useFileUpload = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const restUpload = useFileUploadREST();
  const trpcUpload = useFileUploadTRPC();

  return trpcEnabled ? trpcUpload : restUpload;
};
